var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 86,
    viewBox: "0 0 316 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 28,
    width: 58,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.61 65.17C87.57 63.06 86.55 60.39 86.55 57.17C86.55 53.95 87.57 51.28 89.61 49.17C91.65 47.06 94.21 46 97.29 46C100.44 46 103.04 47.04 105.08 49.11C107.12 51.19 108.14 53.87 108.14 57.17C108.14 60.46 107.12 63.15 105.08 65.23C103.04 67.31 100.44 68.34 97.29 68.34C94.21 68.34 91.65 67.29 89.61 65.17ZM76.99 37.08C71.4 42.6 68.61 49.29 68.61 57.17C68.61 65.19 71.4 71.92 76.99 77.36C82.5 82.8 89.27 85.52 97.29 85.52C105.38 85.52 112.15 82.8 117.59 77.36C123.18 71.92 125.97 65.19 125.97 57.17C125.97 49.29 123.18 42.6 117.59 37.08C112.07 31.57 105.31 28.81 97.29 28.81C89.41 28.81 82.64 31.57 76.99 37.08Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1901 11.82L142.77 34.33L120.39 102.52L51.8101 80.01L74.1901 11.82Z",
    fill: "url(#paint0_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 29,
    width: 35,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.6 32.2C154.63 34.17 152.64 36.87 151.64 40.31V30.32H133.81V84.03H151.64V61.79C151.64 56.92 153.29 53.41 156.58 51.27C159.94 49.12 163.67 48.37 167.75 49.01V29.24C163.96 29.24 160.57 30.23 157.6 32.2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.11 19.18L183.99 34.57L164.45 94.08L117.58 78.7L137.11 19.18Z",
    fill: "url(#paint1_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 28,
    width: 57,
    height: 58
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.05 43.85C205.42 43.85 208.79 46.36 210.15 51.37H189.53C191.02 46.36 194.53 43.85 200.05 43.85ZM179.32 36.98C173.95 42.42 171.26 49.19 171.26 57.28C171.26 65.44 173.98 72.21 179.42 77.58C184.93 82.88 192.24 85.53 201.33 85.53C211.5 85.53 219.2 82.2 224.43 75.54L211.54 66.52C208.82 69.03 205.56 70.28 201.77 70.28C195.54 70.28 191.53 68.1 189.74 63.73H226.8C227.3 61.8 227.55 59.58 227.55 57.07C227.55 48.91 224.93 42.18 219.71 36.88C214.48 31.51 207.86 28.82 199.84 28.82C191.52 28.81 184.69 31.53 179.32 36.98Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.73 12.13L244.35 34.33L222.07 102.2L154.46 80.01L176.73 12.13Z",
    fill: "url(#paint2_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 28,
    width: 48,
    height: 58
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.39 33.54C234.17 36.69 232.05 41.13 232.05 46.86C232.05 49.51 232.55 51.85 233.55 53.9C234.55 55.94 235.97 57.57 237.79 58.79C239.62 60.01 241.4 60.99 243.16 61.74C244.91 62.49 246.87 63.08 249.02 63.51C252.24 64.3 254.59 65 256.05 65.61C257.52 66.22 258.25 66.99 258.25 67.92C258.25 69.85 256.64 70.82 253.42 70.82C249.19 70.82 246.4 68.85 245.04 64.91L229.47 72.75C233.48 81.27 241.5 85.53 253.53 85.53C259.76 85.53 265.2 84.06 269.86 81.13C274.44 78.27 276.73 73.72 276.73 67.49C276.73 64.7 276.21 62.21 275.17 60.02C274.13 57.84 272.7 56.12 270.87 54.86C269.04 53.61 267.22 52.64 265.39 51.96C263.56 51.28 261.57 50.73 259.43 50.3C256.28 49.59 253.93 48.92 252.4 48.31C250.86 47.7 250.09 46.93 250.09 46C250.09 44.28 251.41 43.42 254.06 43.42C256.92 43.42 259.14 44.96 260.72 48.04L275.76 41.27C271.53 32.96 264.16 28.81 253.63 28.81C247.7 28.81 242.62 30.39 238.39 33.54Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.08 14.81L293.55 34.33L272.15 99.53L212.68 80.01L234.08 14.81Z",
    fill: "url(#paint3_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 278,
    y: 15,
    width: 38,
    height: 70
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.41 20.65V30.32H278.35V47.4H286.41V63.41C286.41 71.86 288.56 77.77 292.86 81.13C297.3 84.35 304.82 85.32 315.42 84.03V67.92C311.19 68.14 308.28 67.94 306.66 67.33C305.05 66.72 304.24 65.27 304.24 62.98V47.4H315.41V30.32H304.24V15.28L286.41 20.65Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.96 4.29999L336.16 22.09L311.81 96.29L257.6 78.5L281.96 4.29999Z",
    fill: "url(#paint4_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 41,
    width: 16,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 41.47H5.58997V56.47H20.59V41.47Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.04999 37.03L25.03 42.93L19.13 60.92L1.14001 55.01L7.04999 37.03Z",
    fill: "url(#paint5_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 14,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59 0.470001H11.59V13.47H24.59V0.470001Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.85 -3.38L28.44 1.73999L23.32 17.32L7.73999 12.21L12.85 -3.38Z",
    fill: "url(#paint6_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 22,
    width: 13,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 22.47H0.589966V34.47H12.59V22.47Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75003 18.92L16.14 23.64L11.42 38.03L-2.96997 33.31L1.75003 18.92Z",
    fill: "url(#paint7_linear_106_57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_106_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 8,
    width: 48,
    height: 76
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.59 8.23999V17.47H19.98V39.47H25.59V59.47H19.98V83.43H39.21V57.65H65.64V39.06H39.21V26.82H66.17V8.23999H30.59Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_106_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4799 -5.45001L88.45 15.55L61.6799 97.11L-2.30005 76.11L24.4799 -5.45001Z",
    fill: "url(#paint8_linear_106_57)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_57",
    x1: -63.5229,
    y1: 4.37085,
    x2: 378.641,
    y2: 149.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_57",
    x1: -58.1704,
    y1: -11.9287,
    x2: 383.993,
    y2: 133.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_57",
    x1: -89.727,
    y1: -37.6963,
    x2: 352.437,
    y2: 107.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_57",
    x1: -84.4981,
    y1: -53.6362,
    x2: 357.666,
    y2: 91.4929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_57",
    x1: -78.1959,
    y1: -72.8393,
    x2: 363.968,
    y2: 72.2898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_106_57",
    x1: -69.2953,
    y1: 21.9463,
    x2: 372.868,
    y2: 167.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_106_57",
    x1: -46.963,
    y1: -14.3442,
    x2: 336.246,
    y2: 111.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_106_57",
    x1: -48.3147,
    y1: 10.4763,
    x2: 305.416,
    y2: 126.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#4161AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2351,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_106_57",
    x1: -65.4438,
    y1: 10.2276,
    x2: 376.72,
    y2: 155.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4257A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#35B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForest);
export default __webpack_public_path__ + "static/media/forest.9091eec112063249df48e16d34745ac6.svg";
export { ForwardRef as ReactComponent };